export class SecurityAdjustmentFactorData{
    colId:number;
    rowId:number;
    value:number;
}